<div class="jur">
  <mat-progress-bar *ngIf="loading || busy" mode="indeterminate"></mat-progress-bar>

  <div *ngIf="error" class="jur__error">{{ error }}</div>

  <mat-card class="jur__card">
    <h2 class="jur__title"><mat-icon>rule</mat-icon> Exemption types</h2>
    <p class="jur__muted">Types a taxpayer or cashier picks when a return line claims an exemption.
      Inactive types are hidden from new filings but kept on past returns. A type named "Other"
      requires an explanation.</p>

    <div class="jur__add">
      <input type="text" [(ngModel)]="newName" placeholder="Exemption name" class="jur__add-name" maxlength="100">
      <input type="text" [(ngModel)]="newDescription" placeholder="Description (shown as a hint)" class="jur__add-name" maxlength="500">
      <button mat-flat-button color="primary" [disabled]="busy || !newName.trim()" (click)="add()">
        <mat-icon>add</mat-icon> Add type
      </button>
    </div>

    <table class="jur__table" *ngIf="types.length; else empty">
      <thead>
        <tr><th>Name</th><th>Description</th><th>Order</th><th>Active</th><th></th></tr>
      </thead>
      <tbody>
        <tr *ngFor="let t of types">
          <td><input type="text" [(ngModel)]="t.name" class="jur__add-name" maxlength="100"></td>
          <td><input type="text" [(ngModel)]="t.description" class="jur__add-name" maxlength="500"></td>
          <td><input type="number" [(ngModel)]="t.sortOrder" class="jur__rate" style="width:70px"></td>
          <td><input type="checkbox" [(ngModel)]="t.active"></td>
          <td>
            <button mat-button color="primary" [disabled]="busy || !t.name.trim()" (click)="save(t)">Save</button>
            <span *ngIf="savedId === t.id" class="jur__saved"><mat-icon>check</mat-icon> Saved</span>
          </td>
        </tr>
      </tbody>
    </table>
    <ng-template #empty><p class="jur__muted">No exemption types configured.</p></ng-template>
  </mat-card>
</div>
